import { StackingPlanService } from '../../../../../stacking-plan.service';
import { AbstractSpaceClass } from '../../../../../models/space/abstract-space.class';
import { TenantSpaceClass } from '../../../../../models/space/tenant-space.class';
import { Injectable } from '@angular/core';
import { ActionsToolbarService } from '../../../../actions-toolbar/actions-toolbar.service';
import { ICanSaveSPSpace, SpaceSaveServiceFactory } from './space-save.service';
import { LeaseSpaceSaveService } from './lease-space-save.service';
import { DefaultSpaceSaveService } from './default-space-save.service';

@Injectable()
export class SpaceSaveServiceFactoryService implements SpaceSaveServiceFactory {
  constructor(
    private stackingPlanService: StackingPlanService,
    private actionsToolbarService: ActionsToolbarService
  ) {}

  public getSpaceSaver(space: AbstractSpaceClass): ICanSaveSPSpace {
    if (space instanceof TenantSpaceClass) {
      return new LeaseSpaceSaveService(this.stackingPlanService, this.actionsToolbarService);
    }
    return new DefaultSpaceSaveService(this.stackingPlanService, this.actionsToolbarService);
  }
}
